<template>
  <div class="main">
      <h3>Tasks</h3>
      <!-- Add Task Button and Kanban Switch -->
      <b-row class="align-items-center mb-4">
          <b-col>
              <div class="d-flex justify-content-end align-items-center">
                  <!-- <b-form-checkbox v-model="displayKanban" name="check-button" switch inline class="ml-1">
                      Kanban
                  </b-form-checkbox> -->
                  <b-button v-if="!$route.fullPath.includes('view')" variant="primary" v-b-modal.modal-add-task>
                      Add Task
                  </b-button>
              </div>
          </b-col>
      </b-row>

      <!-- No Tasks Available Message -->
      <div v-if="tasks.length === 0">
          <b-row class="justify-content-center">
              <b-col md="4">
                  <b-card>
                      <b-card-body class="text-center">
                          <h2>No tasks available</h2>
                      </b-card-body>
                  </b-card>
              </b-col>
          </b-row>
      </div>

      <div v-else-if="!displayKanban">
          <div v-if="loading" class="text-center my-4">
              <b-spinner label="Loading tasks..."></b-spinner>
          </div>
<!-- Search Input -->
<b-row class="mb-4 align-items-center">
  <b-col md="4">
    <b-form-input
      v-model="searchQuery"
      placeholder="Search tasks..."
      debounce="300"
    />
  </b-col>
  <b-col md="8" class="text-right">
    <span class="text-muted">
      Showing {{ filteredTasks.length }} of {{ tasks.length }} tasks
    </span>
  </b-col>
</b-row>
          <b-table v-if="!loading" striped hover responsive :items="paginatedTasks" :fields="fields">
              <template #cell(actions)="data">
                  <b-dropdown v-if="!$route.fullPath.includes('view')" id="actions-dropdown" variant="link" size="sm"
                      text="Actions" right no-caret>
                      <template #button-content>
                          <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                      </template>
                      <b-dropdown-item @click="editTask(data.item)">
                          <feather-icon icon="EditIcon" size="16" class="mr-50" />
                          Edit
                      </b-dropdown-item>
                      <b-dropdown-item @click="deleteTask(data.item.id)">
                          <feather-icon icon="TrashIcon" size="16" class="mr-50" />
                          Delete
                      </b-dropdown-item>
                  </b-dropdown>
              </template>
          </b-table>

          <b-pagination v-if="!loading" v-model="currentPage" :per-page="perPage" :total-rows="tasks.length"
              align="center" class="my-2" />
      </div>


      <!-- Tasks Kanban View -->
      <div v-else class="kanban">
          <kanban-task :tasks="tasks" />
      </div>

      <b-modal id="modal-add-task" :title="isEditing ? 'Edit Task' : 'Add Task'" hide-footer size="lg" centered
          @hidden="resetForm">
          <b-form @submit.prevent="validateAndSubmit">
              <b-row>
                  <!-- Title -->
                  <b-col md="12">
                      <b-form-group label="Title" label-for="task_title">
                          <b-form-input id="task_title" placeholder="Title" v-model="newTask.title"
                              :class="{ 'is-invalid': titleState === false }" @blur="validateTitle" />
                          <div class="invalid-feedback" v-if="titleState === false">Title is required</div>
                      </b-form-group>
                  </b-col>

                  <!-- Description -->
                  <b-col md="12">
                      <b-form-group label="Description" label-for="task_description">
                          <b-form-input id="task_description" placeholder="Description" v-model="newTask.description"
                              :class="{ 'is-invalid': descriptionState === false }" @blur="validateDescription" />
                          <div class="invalid-feedback" v-if="descriptionState === false">Description is required
                          </div>
                      </b-form-group>
                  </b-col>

                  <!-- Start Date -->
                  <b-col md="6">
                      <b-form-group label="Start Date" label-for="start_date">
                          <b-form-datepicker id="start_date" :min="currentDate" v-model="newTask.startDate"
                              :class="{ 'is-invalid': startDateState === false }" @input="validateStartDate" />
                          <div class="invalid-feedback" v-if="startDateState === false">Start Date is required</div>
                      </b-form-group>
                  </b-col>

                  <!-- End Date -->
                  <b-col md="6">
                      <b-form-group label="End Date" label-for="end_date">
                          <b-form-datepicker id="end_date" :min="newTask.startDate || currentDate"
                              v-model="newTask.endDate" :class="{ 'is-invalid': endDateState === false }"
                              @input="validateEndDate" />
                          <div class="invalid-feedback" v-if="endDateState === false">End Date must be after Start
                              Date</div>
                      </b-form-group>
                  </b-col>

                  <!-- Assignee -->
                  <b-col md="6">
                      <b-form-group label="Assignee(s)" label-for="assignee">
                          <b-form-select v-model="newTask.assigneeId" :options="assignee_options"
                              :class="{ 'is-invalid': assigneeState === false }" @change="validateAssignee" />
                          <div class="invalid-feedback" v-if="assigneeState === false">Please select an assignee</div>
                      </b-form-group>
                  </b-col>

                  <!-- Status -->
                  <b-col md="6">
                      <b-form-group label="Status" label-for="status">
                          <b-form-select v-model="newTask.status" :options="statusOptions"
                              :class="{ 'is-invalid': statusState === false }" @change="validateStatus" />
                          <div class="invalid-feedback" v-if="statusState === false">Please select a status</div>
                      </b-form-group>
                  </b-col>

                  <!-- Submit Button -->
                  <b-col md="12" class="d-flex justify-content-end">
                      <b-button type="submit" variant="primary">{{ isEditing ? 'Update Task' : 'Add Task'
                          }}</b-button>
                  </b-col>
              </b-row>
          </b-form>
      </b-modal>

  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex";
import KanbanTask from './Kanban.vue'
import {
  BRow,
  BCol,
  BFormCheckbox,
  BButton,
  BCard,
  BCardBody,
  BTable,
  BDropdown,
  BDropdownItem,
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormDatepicker,
  BFormSelect,
  BPagination,
  BSpinner
} from "bootstrap-vue";

export default {
  components: {
      BRow,
      BCol,
      BFormCheckbox,
      BButton,
      BCard,
      BCardBody,
      BTable,
      KanbanTask,
      BDropdown,
      BDropdownItem,
      BModal,
      BForm,
      BFormGroup,
      BFormInput,
      BFormDatepicker,
      BFormSelect,
      BPagination,
      BSpinner
  },
  data() {
      return {
        searchQuery: "",  // Store search input
          loading: true,
          assignee_options: [],
          campaignId: this.$route.params.id,
          tasks: [], // All tasks
          currentPage: 1, // Active page
          perPage: 5, // Number of items per page
          fields: this.getFields(),
          newTask: {
              id: null,
              title: "",
              description: "",
              startDate: "",
              endDate: "",
              assigneeId: "",
              status: "",
          },
          titleState: null,
          descriptionState: null,
          startDateState: null,
          endDateState: null,
          assigneeState: null,
          statusState: null,
          displayKanban: false,
          currentDate: new Date().toISOString().split("T")[0],
          assigneeOptions: ["John Doe", "Jane Smith", "Alice Johnson"],
          priorityOptions: ["Low", "Medium", "High"],
          statusOptions: [
              { value: "NOTSTARTED", text: "Not Started" },
              { value: "INPROGRESS", text: "In Progress" },
              { value: "ONHOLD", text: "On Hold" },
              { value: "COMPLETED", text: "Completed" },
          ],
          isEditing: false, // Flag to indicate editing mode
          editingTaskId: null, // ID of the task being edited
      };
  },
  async mounted() {
      if (!this.campaignId) {
          console.error("Campaign ID is missing from URL!");
          return;
      }
      this.loading = true;
      try {
          const response = await this.getTaskListAction(this.campaignId);
          console.log("Raw API response for tasks:", response);

          // Check if response is structured properly
          if (Array.isArray(response)) {
              this.tasks = response.map(task => ({
                  id: task.id,
                  title: task.title || "Untitled",
                  description: task.description || "no description",
                  assigneeName: task.assigneeName || "Unassigned",
                  priority: "Medium", // Default value since API does not return priority
                  status: task.status || "Not Started",
                  startDate: task.startDate ? task.startDate.split("T")[0] : "N/A",
                  endDate: task.endDate ? task.endDate.split("T")[0] : "N/A",
                  contentName: task.contentName || "No Content",
              }));

              this.totalRows = this.tasks.length;
          } else {
              console.error("Invalid response format:", response);
              this.tasks = [];
          }
      } catch (e) {
          console.error("Error fetching response:", e);
      } finally {
          this.loading = false;
      }

      try {
          const assignee_response = await this.getAssigneeListAction();
          console.log("Raw API response for assignees:", assignee_response);

          if (Array.isArray(assignee_response) && assignee_response.length > 0) {
              this.assignee_options = assignee_response.map(assignee => ({
                  value: assignee.id,
                  text: `${assignee.firstName} ${assignee.lastName}`
              }));
          } else {
              console.warn("No assignees found or unexpected format", assignee_response);
              this.assignee_options = [];
          }
      } catch (error) {
          console.error("Error fetching assignees:", error);
          this.assignee_options = [];
      }

  },
  methods: {
      ...mapActions("marketingModule", [
          "getTaskListAction",
          "getTaskByIdAction",
          "postTaskAction",
          "putTaskAction",
          "deleteTaskAction",
          "getAssigneeListAction"

      ]),

      async fetchTasks() {
          this.loading = true;
          try {
              const response = await this.getTaskListAction(this.campaignId);
              if (Array.isArray(response)) {
                  this.tasks = response.map(task => ({
                      id: task.id,
                      title: task.title || "Untitled",
                      description: task.description || "no description",
                      assigneeName: task.assigneeName || "Unassigned",
                      priority: "Medium", // Default value
                      status: task.status || "Not Started",
                      startDate: task.startDate ? task.startDate.split("T")[0] : "N/A",
                      endDate: task.endDate ? task.endDate.split("T")[0] : "N/A",
                      contentName: task.contentName || "No Content",
                  }));
              } else {
                  console.error("Invalid response format:", response);
                  this.tasks = [];
              }
          } catch (error) {
              console.error("Error fetching tasks:", error);
          } finally {
              this.loading = false;
          }
      },

      async addTask() {
          const taskData = {
              title: this.newTask.title,
              campaignContentsId: this.campaignId,
              description: this.newTask.description,
              startDate: this.newTask.startDate,
              endDate: this.newTask.endDate,
              priority: "NOTSPECIFIED",
              assigneeName: this.assignee_options.find(a => a.value === this.newTask.assigneeId)?.text || "",
              assignee: this.newTask.assigneeId,
              status: this.newTask.status,
              campaignId: this.campaignId,
          };

          console.log("Task data to be added:", taskData);

          try {
              const loadingSwal = Swal.fire({
                  title: "Adding Task...",
                  text: "Please wait while the task is being added.",
                  allowOutsideClick: false,
                  didOpen: () => {
                      Swal.showLoading();
                  },
              });

              const response = await this.postTaskAction(taskData);

              console.log("API response:", response);

              if (response && response.success) {
                  loadingSwal.close();

                  Swal.fire({
                      title: "Success!",
                      text: "Task added successfully.",
                      icon: "success",
                      confirmButtonText: "OK",
                  });

                  // Add task to the task list locally
                  this.tasks.push(response.result);

                  // Close the modal and reset the form
                  this.$bvModal.hide("modal-add-task");
                  this.resetForm();

                  // Refresh the tasks from API
                  await this.fetchTasks();
              } else {
                  throw new Error("Failed to add task. Please try again.");
              }
          } catch (error) {
              console.error("Error adding task:", error);

              Swal.fire({
                  title: "Error!",
                  text: error.message || "Something went wrong while adding the task.",
                  icon: "error",
                  confirmButtonText: "Try Again",
              });
          }
      },
      resetForm() {
          this.newTask = {
              id: null,
              title: "",
              description: "",
              startDate: "",
              endDate: "",
              assigneeId: "",
              status: "NOTSTARTED",
          };
          this.isEditing = false;
          this.editingTaskId = null;
      },
      editTask(task) {
          this.newTask = {
              id: task.id,
              title: task.title,
              description: task.description,
              startDate: task.startDate,
              endDate: task.endDate,
              assigneeId: this.assignee_options.find(assignee => assignee.text === task.assigneeName)?.value || "",
              status: task.status,
          };
          this.editingTaskId = task.id;  // Save the ID of the task being edited
          this.isEditing = true;  // Set editing mode
          this.$bvModal.show("modal-add-task");
      }
      ,
      async updateTask() {
          const taskData = {
              taskid: this.newTask.id,
              title: this.newTask.title,
              description: this.newTask.description,
              startDate: this.newTask.startDate,
              endDate: this.newTask.endDate,
              assignee: this.newTask.assigneeId,
              assigneeName: this.assignee_options.find(a => a.value === this.newTask.assigneeId)?.text || "",
              status: this.newTask.status,
              campaignId: this.campaignId,
              priority: "NOTSPECIFIED",
          };
          console.log("Task data to be updated:", taskData);

          try {
              const loadingSwal = Swal.fire({
                  title: "Updating Task...",
                  text: "Please wait while the task is being updated.",
                  allowOutsideClick: false,
                  didOpen: () => {
                      Swal.showLoading();
                  },
              });

              const response = await this.putTaskAction(taskData);

              if (response && response.success) {
                  loadingSwal.close();

                  Swal.fire({
                      title: "Success!",
                      text: "Task updated successfully.",
                      icon: "success",
                      confirmButtonText: "OK",
                  });

                  // Refresh the task list after update
                  await this.fetchTasks();

                  // Close the modal and reset the form
                  this.$bvModal.hide("modal-add-task");
                  this.resetForm();
              } else {
                  throw new Error("Failed to update task. Please try again.");
              }
          } catch (error) {
              console.error("Error updating task:", error);

              Swal.fire({
                  title: "Error!",
                  text: "Something went wrong while updating the task, please try again later",
                  icon: "error",
                  confirmButtonText: "Try Again",
              });
          }
      },
      async deleteTask(taskId) {
          console.log("Task ID to delete:", taskId);

          const result = await Swal.fire({
              title: "Are you sure?",
              text: "You won't be able to revert this!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes, delete it!",
              cancelButtonText: "Cancel",
              didOpen: () => {
                  document.querySelector(".swal2-actions").style.display = "flex";
                  document.querySelector(".swal2-actions").style.justifyContent = "center";
                  document.querySelector(".swal2-actions").style.gap = "20px";
              },
          });

          if (result.isConfirmed) {
              try {
                  const loadingSwal = Swal.fire({
                      title: "Deleting Task...",
                      text: "Please wait while the task is being deleted.",
                      allowOutsideClick: false,
                      didOpen: () => {
                          Swal.showLoading();
                      },
                  });

                  // Call the Vuex action
                  const response = await this.deleteTaskAction(taskId);

                  console.log("Delete API Response:", response);

                  if (response && response.success) {
                      loadingSwal.close();

                      Swal.fire({
                          title: "Deleted!",
                          text: response.message || "Task has been deleted successfully.",
                          icon: "success",
                          confirmButtonText: "OK",
                          customClass: {
                              confirmButton: "btn btn-primary",
                          },
                          buttonsStyling: false,
                      });

                      // Refresh the task list after deletion
                      await this.fetchTasks();
                  } else {
                      throw new Error(response.message || "Failed to delete the task. Please try again.");
                  }
              } catch (error) {
                  console.error("Error deleting task:", error);

                  Swal.fire({
                      title: "Error!",
                      text: error.message || "Something went wrong while deleting the task.",
                      icon: "error",
                      confirmButtonText: "Try Again",
                      customClass: {
                          confirmButton: "btn btn-danger",
                      },
                      buttonsStyling: false,
                  });
              }
          }
      },
      getFields() {
          const baseFields = [
              { key: "title", label: "Title" , sortable: true},
              { key: "description", label: "Description", sortable: true},
              { key: "assigneeName", label: "Assignee" , sortable: true},
              { key: "status", label: "Status" , sortable: true},
              { key: "startDate", label: "Start Date" , sortable: true},
              { key: "endDate", label: "End Date" , sortable: true},
              { key: "contentName", label: "Content Name" , sortable: true},
              { key: "startDate", label: "Start Date" , sortable: true},
          ];
          // Check if 'view' exists in the URL
          if (!this.$route.fullPath.includes("view")) {
              baseFields.push({ key: "actions", label: "Actions" });
          }
          return baseFields;
      },
      validateTitle() {
          this.titleState = this.newTask.title.trim() !== "" ? true : false;
      },
      validateDescription() {
          this.descriptionState = this.newTask.description.trim() !== "" ? true : false;
      },
      validateStartDate() {
          this.startDateState = this.newTask.startDate ? true : false;
      },
      validateEndDate() {
          this.endDateState = this.newTask.endDate && this.newTask.endDate >= this.newTask.startDate ? true : false;
      },
      validateAssignee() {
          this.assigneeState = this.newTask.assigneeId ? true : false;
      },
      validateStatus() {
          this.statusState = this.newTask.status ? true : false;
      },
      validateAndSubmit() {
          this.validateTitle();
          this.validateDescription();
          this.validateStartDate();
          this.validateEndDate();
          this.validateAssignee();
          this.validateStatus();

          if (this.titleState && this.descriptionState && this.startDateState && this.endDateState && this.assigneeState && this.statusState) {
              this.isEditing ? this.updateTask() : this.addTask();
          } else {
              this.$swal({
                  title: "Validation Error",
                  text: "Please fill in all required fields.",
                  icon: "error",
                  confirmButtonText: "OK",
                  customClass: {
                      confirmButton: "btn btn-danger",
                  },
              });
          }
      },
      resetForm() {
          // Reset form fields
          this.newTask = {
              id: null,
              title: "",
              description: "",
              startDate: "",
              endDate: "",
              assigneeId: "",
              status: "NOTSTARTED",
          };
          // Reset validation states
          this.titleState = null;
          this.descriptionState = null;
          this.startDateState = null;
          this.endDateState = null;
          this.assigneeState = null;
          this.statusState = null;

          // Reset edit flag
          this.isEditing = false;
      }
  },
  computed: {
    paginatedTasks() {
    const start = (this.currentPage - 1) * this.perPage;
    const end = start + this.perPage;
    return this.filteredTasks.slice(start, end); // Use filtered tasks
  },
      filteredTasks() {
    if (!this.searchQuery) {
      return this.tasks;
    }
    
    const query = this.searchQuery.toLowerCase();
    
    return this.tasks.filter(task =>
      task.title.toLowerCase().includes(query) ||
      task.description.toLowerCase().includes(query) ||
      task.assigneeName.toLowerCase().includes(query) ||
      task.status.toLowerCase().includes(query)
    );
  },
  },
};
</script>

<style>
.main {
  padding: 20px;
}

.kanban-columns {
  display: flex;
  gap: 20px;
}

.kanban-column {
  flex: 1;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
  background-color: #f9f9f9;
}

.kanban-tasks {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.kanban-task {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;
}

.spinner {
  margin-top: 20px;
  text-align: center;
}

.swal-actions-spacing {
  display: flex;
  justify-content: center;
  /* Align buttons in the center */
  gap: 15px;
  /* Adjust space between buttons */
}

/* Optional: Adjust individual button margins */
.swal-confirm-btn {
  padding: 8px 16px;
}

.swal-cancel-btn {
  padding: 8px 16px;
}
</style>
